import { convertDistance as turfConvertDistance } from '@turf/turf';

/**
 * Converts a distance from one unit to another.
 * @param distance The distance to convert.
 * @param from The original unit of the distance.
 * @param to The unit to convert the distance to.
 * @returns The converted distance.
 */
export function convertDistance(
  distance: number,
  from: 'meters' | 'miles',
  to: 'kilometers' | 'miles',
) {
  try {
    const convertedDistance: number = turfConvertDistance(
      Math.abs(distance),
      from,
      to,
    );
    return convertedDistance;
  } catch (error) {
    console.error(error);
    return distance;
  }
}
